export default __webpack_public_path__ + "static/media/ready-to-use.883d142c.svg";